import { Email } from '~models';
import { getField, updateField } from 'vuex-map-fields';
import emails from '../api/emails';

const SET_EMAIL = 'SET_EMAIL';
const RESET_EMAIL = 'RESET_EMAIL';
const SET_EMAIL_INDEX = 'SET_EMAIL_INDEX';
const RESET_EMAIL_INDEX = 'RESET_EMAIL_INDEX';
const TRIGGER_MODAL = 'TRIGGER_MODAL';
const LOADING = 'LOADING';

const state = {
    email: { ...new Email() },
    emailIndex: -1,
    showModal: false,
    isLoading: false
};

const actions = {
    /**
     * Reset email state
     * @param {function} commit
     */
    resetEmail({ commit }) {
        commit(RESET_EMAIL);
        commit(RESET_EMAIL_INDEX);
        commit(TRIGGER_MODAL);
    },

    /**
     * Add email to program email list
     * @param {function} commit
     */
    async addEmail({ commit, state, dispatch }, param) {
        const params = {
            index: state.emailIndex,
            data: state.email
        };

        if (param === 'program') {
            await dispatch('programs/addEmail', params, { root: true });
        } else {
            await dispatch('businesses/addEmail', params, { root: true });
        }

        commit(RESET_EMAIL);
        commit(RESET_EMAIL_INDEX);
        commit(TRIGGER_MODAL);
    },

    /**
     * Trigger modal window open/close
     * @param {function} commit
     */
    triggerModal({ commit }) {
        commit(TRIGGER_MODAL);
    },

    /**
     * Set email for editing
     * @param {function}commit
     * @param {numeber} index
     * @param {object} data
     */
    setEmail({ commit }, params) {
        const { index, data } = params;
        commit(SET_EMAIL, data);
        commit(SET_EMAIL_INDEX, index);
        commit(TRIGGER_MODAL);
    },

    /**
     * Upload image for email in editor
     * @param {function} commit
     */
    async uploadImage({ commit }, data) {
        commit(LOADING);

        const resp = await emails.uploadImage(data);

        commit(LOADING);

        return resp;
    }
};

const mutations = {
    // Add the `updateField` mutation to the
    // `mutations` of your Vuex store instance.
    updateField,
    [SET_EMAIL](state, data) {
        state.email = data;
    },
    [SET_EMAIL_INDEX](state, index) {
        state.emailIndex = index;
    },
    [RESET_EMAIL_INDEX](state) {
        state.emailIndex = -1;
    },
    [RESET_EMAIL](state) {
        state.email = { ...new Email() };
    },
    [TRIGGER_MODAL](state) {
        state.showModal = !state.showModal;
    },
    [LOADING](state) {
        state.isLoading = !state.isLoading;
    }
};

const getters = {
    // Add the `getField` getter to the
    // `getters` of your Vuex store instance.
    getField,
    isLoading: state => state.isLoading,
    email: state => state.program.email,
    emailIndex: state => state.emailIndex,
    showModal: state => state.showModal
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
